<template>
  <el-dialog
    class="rc-dialog"
    :title="title"
    :visible.sync="showEditModal.flag"
    :close-on-click-modal="false"
    destroy-on-close
    @close="closeDialog"
    width="500px"
  >
    <el-form
      ref="editForm"
      :model="ruleForm"
      size="small"
      :rules="rules"
      label-width="90px"
      class="form"
    >
      <el-row>
        <el-col>
          <el-form-item label="标签名称：" prop="name">
            <el-input
              v-model="ruleForm.name"
              placeholder="请输入标签名称"
              maxlength="25"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeDialog" title="取消"></butn>
      <butn btntype="primary" @click.native="submitForm()" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import rulesFactory from "@/utils/rules";
import {
  getOrganizationTagInfo,
  saveOrganizationTag,
  updateOrganizationTag,
} from "@/api/user";

export default {
  name: "editLineManage",
  components: { butn },
  props: {
    showEditModal: {
      type: Object,
      default: () => {
        return {
          flag: false,
          uuid: "",
        };
      },
    },
  },
  data() {
    return {
      isShow: false,
      title: "新增标签",
      ruleForm: {
        uuid: "",
        name: "",
      },
      rules: {
        name: [rulesFactory.required("请输入标签名称")],
      },
    };
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog", false);
    },
    submitForm() {
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          if (!this.ruleForm.uuid) {
            // 新增
            saveOrganizationTag(this.ruleForm).then((res) => {
              if (!res || res.code != 0) return;
              this.$emit("closeDialog", true);
            });
          } else {
            //编辑
            updateOrganizationTag(this.ruleForm).then((res) => {
              if (!res || res.code != 0) return;
              this.$emit("closeDialog", true);
            });
          }
        }
      });
    },
  },
  created() {
    if (this.showEditModal.uuid) {
      this.title = "编辑标签";
      getOrganizationTagInfo(this.showEditModal.uuid).then((res) => {
        if (!res || res.code != 0) return;
        this.ruleForm = res.data;
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.rc-dialog {
  /deep/ .form {
    .el-form-item {
      margin-bottom: 0;
    }
    .el-form-item--small.el-form-item {
      margin: 0;
    }
  }
}
</style>
